"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.EditPatients = void 0;
const confirmation_modal_1 = require("client/components/confirmation-modal");
const filter_header_1 = require("client/components/filter-header");
const icons_1 = require("client/components/icons");
const button_1 = require("client/components/material/button");
const checkbox_1 = require("client/components/material/checkbox/checkbox");
const list_1 = require("client/components/material/list");
const list_item_1 = require("client/components/material/list/list-item");
const list_item_text_1 = require("client/components/material/list/list-item/list-item-text");
const ui_1 = require("client/components/ui");
const callable_1 = require("client/components/ui/callable");
const store_1 = require("client/modules/sites/modules/sites-detail/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const moment = require("moment");
const ramda_1 = require("ramda");
const React = require("react");
const react_1 = require("react");
const ReactTooltip = require("react-tooltip");
const capitalize_string_1 = require("shared/util/capitalize-string");
const throttle_debounce_1 = require("throttle-debounce");
require("./edit-patients.less");
const columns = [
    {
        center: false,
        id: "patient.id",
        numeric: false,
        label: "Patient ID"
    },
    {
        center: false,
        id: "patient.lastName",
        label: "Name",
        numeric: false
    },
    {
        center: false,
        id: "patient.birthDate",
        label: "Date of Birth",
        numeric: false
    },
    {
        center: false,
        // id: "nextAppt",
        id: "NO_ACTION",
        label: "Next Appt",
        numeric: false,
        sortable: false
    },
    {
        center: false,
        // id: "nextRefill",
        id: "NO_ACTION",
        label: "Next Refill",
        numeric: false
    },
    {
        center: false,
        id: "patient.missingInsurance",
        label: "",
        numeric: true
    }
];
let EditPatients = class EditPatients extends react_1.Component {
    constructor() {
        super(...arguments);
        this.numChecked = 0;
        this.indeterminate = false;
        this.checkedAll = false;
        this.checkedBoxes = {};
        this.checkedRowId = -1;
        this.editRowIndex = -1;
        this.currentRowIndex = -1;
        this.order = "ASC";
        this.orderBy = "patient.lastName";
        this.showAll = false;
        this.filterText = "";
        this.showConfirmationEditPatientSave = false;
        this.loadPatients = throttle_debounce_1.debounce(200, () => {
            if (store_1.sitesDetailStore.site.value) {
                store_1.sitesDetailStore.loadEditPatients({
                    id: store_1.sitesDetailStore.site.value.id,
                    order: this.order,
                    search: this.filterText,
                    sort: this.orderBy
                });
                store_1.sitesDetailStore.loadPatients({
                    id: store_1.sitesDetailStore.site.value.id,
                    order: this.order,
                    search: this.filterText,
                    sort: this.orderBy
                });
            }
        });
        this.onRequestSort = (property) => {
            if (this.orderBy === property) {
                this.order === "ASC" ? (this.order = "DESC") : (this.order = "ASC");
            }
            else {
                this.orderBy = property;
                this.order = "ASC";
            }
            this.loadPatients();
        };
        this.onCallback = (value) => {
            this.filterText = value;
            this.loadPatients();
        };
        this.renderTable = () => (React.createElement(ui_1.UiForm, { buttons: this.showAll
                ? [
                    React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"),
                    "Save"
                ]
                : [], loading: this.props.loading, isChanged: this.isChanged, status: this.status || this.props.status, saved: "Saved", onSubmit: this.handleSubmit, error: this.props.error },
            React.createElement("div", { className: "patients__list" },
                this.showAll && store_1.sitesDetailStore.editPatients.value && (React.createElement(list_1.MaterialList, { checkbox: this.renderCheckAll(), columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: store_1.sitesDetailStore.editPatients.value, renderRow: this.renderTableRow, wideHeader: false, resizableheader: true, customClass: "custom-material-list__site-patients-list" })),
                !this.showAll && store_1.sitesDetailStore.patients.value && (React.createElement(list_1.MaterialList, { columns: columns, onRequestSort: this.onRequestSort, order: this.order, orderBy: this.orderBy, rows: store_1.sitesDetailStore.patients.value, renderRow: this.renderTableRow, wideHeader: false, resizableheader: true, customClass: "custom-material-list__site-patients-list" })))));
        this.renderTableRow = (row, index) => {
            const displayName = `${row.lastName}, ${row.firstName}`;
            const birthday = moment(row.birthDate)
                .format("MM/DD/YYYY")
                .replace("Invalid date", "");
            const nextApt = !!row.nextAppointment
                ? moment(row.nextAppointment).isBefore(new Date())
                    ? "NOW"
                    : `${moment(row.nextAppointment).format("MM/DD/YYYY hh:mm A")}`
                : "";
            const nextRefill = !!row.nextRefill
                ? moment(row.nextRefill).isBefore(new Date())
                    ? "NOW"
                    : `${moment(row.nextRefill).format("MM/DD/YYYY")}`
                : "";
            return (React.createElement(list_item_1.MaterialListItem, { key: index, to: !this.showAll
                    ? `../../patients/${row.id}/${this.props.site ? this.props.site.id : 0}`
                    : "" },
                React.createElement(list_item_text_1.MaterialListItemText, { primary: row.id }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: capitalize_string_1.capitalizeString(displayName) }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: birthday }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: nextApt }),
                React.createElement(list_item_text_1.MaterialListItemText, { primary: nextRefill }),
                React.createElement(list_item_text_1.MaterialListItemText, { "data-tip": row.missingInsurance
                        ? "Patient is missing insurance information"
                        : "", primary: row.missingInsurance && React.createElement(icons_1.WarningIcon, { fill: "#eeb20d" }) })));
        };
        this.handleToggle = () => {
            this.showAll = !this.showAll;
            if (this.showAll) {
                this.initializeCheckBoxes();
            }
        };
        this.isChanged = () => {
            if (!this.props.site)
                return false;
            if (!store_1.sitesDetailStore.editPatients.value)
                return false;
            const siteId = this.props.site.id;
            let changed = false;
            for (const patient of store_1.sitesDetailStore.editPatients.value) {
                const site = patient.sites.find(site => site.id === siteId);
                if (site && this.checkedBoxes[patient.id] !== true) {
                    changed = true;
                    break;
                }
                if (!site && this.checkedBoxes[patient.id] === true) {
                    changed = true;
                    break;
                }
            }
            return changed;
        };
        this.updateNumChecked = () => {
            let numChecked = 0;
            for (const key in this.checkedBoxes) {
                if (this.checkedBoxes[key]) {
                    numChecked++;
                }
            }
            this.numChecked = numChecked;
            if (this.numChecked === 0) {
                this.checkedAll = false;
                this.indeterminate = false;
            }
            else if (store_1.sitesDetailStore.editPatients.value &&
                this.numChecked === store_1.sitesDetailStore.editPatients.value.length) {
                this.checkedAll = true;
                this.indeterminate = false;
            }
            else {
                this.indeterminate = true;
            }
        };
        this.handleCheckRow = (child) => {
            this.checkedRowId = child.id;
            this.checkedBoxes = ramda_1.merge(this.checkedBoxes, {
                [child.id]: !this.checkedBoxes[child.id]
            });
            this.updateNumChecked();
            if (this.isChanged()) {
                this.status = ui_1.FormStatus.Dirty;
            }
            else {
                this.status = null;
            }
        };
        this.handleCheckAll = () => {
            if (this.checkedAll) {
                this.checkedBoxes = {};
            }
            else {
                store_1.sitesDetailStore.editPatients.value &&
                    store_1.sitesDetailStore.editPatients.value.map(patient => {
                        this.checkedBoxes = ramda_1.merge(this.checkedBoxes, {
                            [patient.id]: true
                        });
                    });
            }
            this.checkedAll = !this.checkedAll;
            this.updateNumChecked();
            if (this.isChanged()) {
                this.status = ui_1.FormStatus.Dirty;
            }
            else {
                this.status = null;
            }
        };
        this.handleCancel = () => {
            this.filterText = "";
            this.showAll = false;
            this.loadPatients();
        };
        this.handleSubmit = () => {
            if (!this.props.site)
                return;
            if (!store_1.sitesDetailStore.editPatients.value)
                return;
            const siteId = this.props.site.id;
            const patientsAdded = [];
            const patientsRemoved = [];
            for (const patient of store_1.sitesDetailStore.editPatients.value) {
                const site = patient.sites.find(site => site.id === siteId);
                if (site && this.checkedBoxes[patient.id] !== true) {
                    patientsRemoved.push(patient);
                }
                if (!site && this.checkedBoxes[patient.id] === true) {
                    patientsAdded.push(patient);
                }
            }
            callable_1.callable(this.props.onSave)(this.props.site, patientsAdded, patientsRemoved);
            this.showConfirmationEditPatientSave = false;
        };
    }
    componentDidUpdate() {
        ReactTooltip.rebuild();
    }
    componentWillReceiveProps(props) {
        this.status = props.status;
    }
    render() {
        return (React.createElement("div", { className: "edit-patients" },
            this.renderFilter(),
            this.renderTable(),
            React.createElement(ReactTooltip, { effect: "solid", place: "left" }),
            this.showConfirmationEditPatientSave && (React.createElement(confirmation_modal_1.ConfirmationModal, { confirmText: "Save", cancelText: "Cancel", message: `Please confirm save. <br />Do you want to save the changes to this patient?`, onCancel: () => {
                    this.showConfirmationEditPatientSave = false;
                }, onConfirm: this.handleSubmit, title: "Save confirmation" }))));
    }
    renderCheckAll() {
        return (React.createElement(checkbox_1.MaterialCheckbox, { onAction: this.handleCheckAll, label: "", checked: this.checkedAll, indeterminate: this.indeterminate }));
    }
    renderFilter() {
        return (React.createElement("div", { className: "patients__filter" },
            React.createElement(filter_header_1.FilterHeader, { label: "Search", 
                // switchChecked={this.showAll}
                // switchLabel="Edit Patients"
                title: "Patients", 
                // withSwitch={usersStore.permissions.ReadPatients}
                callBack: this.onCallback, filterText: this.filterText })));
    }
    initializeCheckBoxes() {
        this.checkedBoxes = {};
        const siteId = this.props.site && this.props.site.id;
        if (store_1.sitesDetailStore.editPatients.value) {
            for (const editPatient of store_1.sitesDetailStore.editPatients.value) {
                if (editPatient.sites.find(site => site.id === siteId)) {
                    this.checkedBoxes = ramda_1.merge(this.checkedBoxes, {
                        [editPatient.id]: true
                    });
                }
            }
        }
        this.updateNumChecked();
    }
};
__decorate([
    mobx_1.observable
], EditPatients.prototype, "numChecked", void 0);
__decorate([
    mobx_1.observable
], EditPatients.prototype, "indeterminate", void 0);
__decorate([
    mobx_1.observable
], EditPatients.prototype, "checkedAll", void 0);
__decorate([
    mobx_1.observable
], EditPatients.prototype, "checkedBoxes", void 0);
__decorate([
    mobx_1.observable
], EditPatients.prototype, "checkedRowId", void 0);
__decorate([
    mobx_1.observable
], EditPatients.prototype, "editRowIndex", void 0);
__decorate([
    mobx_1.observable
], EditPatients.prototype, "currentRowIndex", void 0);
__decorate([
    mobx_1.observable
], EditPatients.prototype, "order", void 0);
__decorate([
    mobx_1.observable
], EditPatients.prototype, "orderBy", void 0);
__decorate([
    mobx_1.observable
], EditPatients.prototype, "showAll", void 0);
__decorate([
    mobx_1.observable
], EditPatients.prototype, "status", void 0);
__decorate([
    mobx_1.observable
], EditPatients.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], EditPatients.prototype, "showConfirmationEditPatientSave", void 0);
EditPatients = __decorate([
    mobx_react_1.observer
], EditPatients);
exports.EditPatients = EditPatients;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/sites/modules/sites-detail/components/edit-patients/edit-patients.tsx
// module id = 4048
// module chunks = 0